import { render, staticRenderFns } from "./JoinedDetail.vue?vue&type=template&id=e4b03ea0&scoped=true&"
import script from "./JoinedDetail.vue?vue&type=script&lang=js&"
export * from "./JoinedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b03ea0",
  null
  
)

export default component.exports